import { render, staticRenderFns } from "./HighlightsComponent.vue?vue&type=template&id=3a98f27e"
import script from "./HighlightsComponent.vue?vue&type=script&lang=ts"
export * from "./HighlightsComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports